import { render, staticRenderFns } from "./BuyPrintView.vue?vue&type=template&id=5146d65a&scoped=true&"
import script from "./BuyPrintView.vue?vue&type=script&lang=js&"
export * from "./BuyPrintView.vue?vue&type=script&lang=js&"
import style0 from "./BuyPrintView.vue?vue&type=style&index=0&id=5146d65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5146d65a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
